// Marketing · Formularios (montado en /marketing/formularios/*): lista, detalle y editor.
import type { JSX } from "react";
import { Route, Routes } from "react-router-dom";
import { FormList } from "./forms/FormList.tsx";
import { FormDetail } from "./forms/FormDetail.tsx";
import { FormEditor } from "./forms/FormEditor.tsx";

export function MktForms(): JSX.Element {
  return (
    <Routes>
      <Route index element={<FormList />} />
      <Route path=":id" element={<FormDetail />} />
      <Route path=":id/editar" element={<FormEditor />} />
    </Routes>
  );
}
